module.exports = "/_next/static/images/6d405595329b84b97c72355eb9cd7f57-wow@0.75x.png.webp";